/*
 * COPYRIGHT. HSBC HOLDINGS PLC 2017. ALL RIGHTS RESERVED.
 *
 * This software is only to be used for the purpose for which it has been
 * provided. No part of it is to be reproduced, disassembled, transmitted,
 * stored in a retrieval system nor translated in any human or computer
 * language in any way or for any other purposes whatsoever without the
 * prior written consent of HSBC Holdings plc.
 *
 */
import React from 'react';
import BasePage from '../../../shared/BasePage';
import AOForm from '../../../shared/AOForm';
import { getContentByLocal } from '../../../utils';

/*eslint-disable array-callback-return*/
class CompanyRegistrationItem extends BasePage {

    selectOptions = (staticData, i18n, selectedLanguage) => {
        let indicator = ['000'];
        let selectOptions = [{
            id: '000',
            text: i18n.registerCountry.placeHolder,
            dataKey: 'pleaseSelect'
        }];
        staticData && staticData.map(options => {
            indicator.push(options.indicator);
            selectOptions.push({
                id: options.indicator, 
                text: getContentByLocal(options.leveLocales, selectedLanguage), 
                dataKey: options.indicator
            })
        })
        return {
            indicator,
            selectOptions
        }
    }

    initalData = () => {
        const { i18n, currentSection, errorMsgs, errorList, staticData, selectedLanguage } = this.props;
        const { selectOptions } = this.selectOptions(staticData, i18n, selectedLanguage);
        const isChina = currentSection.registerCountry === 'CN';
        return {
            registerCountry: {
                dataKey: 'registerCountry',
                itemTitle: {
                    text: i18n.registerCountry.title,
                    dataKey: 'businessRegion'
                },
                questionMark: {
                    hints: i18n.registerCountry.hints,
                    dataKey: 'registerCountryHints'
                },
                defaultValue: currentSection.registerCountry,
                selectOptions: selectOptions.map(key => {
                    return ({id: key.id, text: key.text, dataKey: key.dataKey})
                }),
                validatedTips: errorMsgs['registerCountry'],
                isError: errorList.indexOf('registerCountry') !== -1
            },
            registationCode: {
                textValue: '',
                subtitle:{
                    title: i18n.registationCode.title,
                    dataKey: 'registationCodeTitle'
                },
                placeholder: isChina ? i18n.registationCode.placeHolderChina : i18n.registationCode.placeHolder,
                isDisabled: true,
                dataKey: 'registationCode'
            },
            comDocType: {
                selectOptions: i18n.registationCode.chinaOptions.map(key => {
                    return ({id: key.id, text: key.text, dataKey: key.dataKey})
                }),
                defaultValue: currentSection.comDocType,
                itemTitle:{
                    text: i18n.registationCode.title,
                    dataKey: 'registationCodeTitle'
                },
                validatedTips: errorMsgs.comDocType,
                isError: errorList.indexOf('comDocType') !== -1,
                dataKey: 'comDocType'
            },
            comDocNum: {
                textValue: currentSection.comDocNum,
                subtitle:{
                    title: isChina ? i18n.comDocNum.titleChina : i18n.comDocNum.title,
                    dataKey: 'comDocNumTitle'
                },
                questionMark: {
                    hints: isChina ? i18n.comDocNum.hintsChina : i18n.comDocNum.hints,
                    dataKey: 'comDocNumHints'
                },
                dataLabel: "comDocNumHints",
                isError: errorList.indexOf('comDocNum') !== -1,
                errorMessage: errorMsgs['comDocNum'],
                dataKey: 'comDocNum'
            }
        }
    }

    render () {
        const { onChangeAnswerForm, currentSection, onBlurAction } = this.props;
        const {
            registerCountry,
            registationCode,
            comDocType,
            comDocNum
        } = this.initalData();
        return (
            <div data-id={'CompanyRegistrationItem-CompanyRegistrationItem-page'}>

                {/*Country of Registration*/}
                <div className="form-item">
                    <AOForm.Select
                        content={registerCountry}
                        onChangeAction={ (questionRel, value, event) => onChangeAnswerForm(value, 'registerCountry') }
                    />
                </div>

                {
                    currentSection.registerCountry !== '' &&
                    <div>
                        <div className="form-item">
                        {
                            currentSection.registerCountry === 'CN' ? 
                        <AOForm.Select
                            content={comDocType}
                            onChangeAction={ (questionRel, value, event) => onChangeAnswerForm(value, 'comDocType') }
                        /> :
                            <AOForm.InputWithPrefixSuffix
                                onChangeAction={ (questionRel, value) => onChangeAnswerForm(value, 'registationCode') }
                                content={registationCode}
                            />
                        }
                        </div>

                        <div className="form-item">
                            <AOForm.InputWithPrefixSuffix
                                onChangeAction={ (questionRel, value) => onChangeAnswerForm(value, 'comDocNum') }
                                onBlurAction={(questionRel, value) => onBlurAction(value, 'comDocNum') }
                                content={comDocNum}
                                maxLength={currentSection.registerCountry === 'CN' ? (currentSection.comDocType === '1' ? 18 : 15) : 10000}
                            />
                        </div>
                    </div>
                }
                
            </div>
        )
    }
}

export default CompanyRegistrationItem;



// WEBPACK FOOTER //
// ./src/views/CompanyRegistration/components/CompanyRegistrationItem.js